import React from 'react';

import RadioCheckIcon from '@/components/Icon/RadioCheckIcon';
import RadioIcon from '@/components/Icon/RadioIcon';
import { colors } from '@/const/colors';
import { Box, FormControlLabel, Radio, RadioGroup } from '@mui/material';

export interface OptionType {
  code: string;
  desc: string;
  count?: number;
}

interface RadioListProps {
  name: string;
  list: OptionType[];
  value: string;
  onChange: (val: OptionType) => void;
  horizontal?: boolean;
  justify?: 'between' | 'equal';
  isDisabled?: boolean;
}

const RadioList = ({
  name,
  list,
  value,
  onChange,
  horizontal = true,
  justify = 'between',
  isDisabled = false,
}: RadioListProps) => {
  // justify="equal"이고 항목이 2개일 때, 보이지 않는 빈 항목을 추가하여 3개로 만듬
  const displayList =
    justify === 'equal' && list.length === 2 ? [...list, { code: '__empty__', desc: '', count: undefined }] : list;

  return (
    <RadioGroup
      value={value}
      row={horizontal}
      name={`radio-buttons-group ${name}`}
      sx={{ justifyContent: justify === 'between' || justify === 'equal' ? 'space-between' : 'normal' }}
    >
      {displayList.map((item, index) => {
        const isEmpty = item.code === '__empty__';

        const formControlLabel = (
          <FormControlLabel
            value={item.code}
            control={
              <Radio
                icon={<RadioIcon color={colors.gray[3]} />}
                checkedIcon={<RadioCheckIcon color={isDisabled ? colors.gray[3] : colors.primary[10]} />}
                sx={{
                  borderWidth: '4px',
                  fontSize: '14px',
                  borderRadius: '10px',
                  paddingRight: '6px',
                }}
              />
            }
            disabled={isDisabled || isEmpty}
            checked={item.code === value}
            label={
              <>
                <span
                  className={`text-gray-9 ${
                    justify === 'equal' ? 'w-[28px] whitespace-nowrap overflow-visible inline-block' : ''
                  }`}
                >
                  {item.desc}
                </span>
                {!!item.count && (
                  <span>
                    <span className="text-gray-5">({item.count})</span>
                  </span>
                )}
              </>
            }
            onChange={() => !isEmpty && onChange(item)}
          />
        );

        if (horizontal === false) {
          return <React.Fragment key={isEmpty ? 'empty' : index}>{formControlLabel}</React.Fragment>;
        }

        return (
          <Box
            key={isEmpty ? 'empty' : index}
            sx={{
              ...(isEmpty && {
                visibility: 'hidden',
                pointerEvents: 'none',
              }),
            }}
          >
            {formControlLabel}
          </Box>
        );
      })}
    </RadioGroup>
  );
};

export default RadioList;
